const courses = [
    {
        path: '/courses',
        name: 'Courses',
        component: () => import('@/views/courses'),
        children: [],
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/courses/:id',
        name: 'CourseDetails',
        component: () => import('@/views/courses/Details'),
        children: [],
        meta: {
            requiresAuth: false,
        },
        props: (route) => ({ id: route.params.id }),
    },
    {
        path: '/courses/:id/learn',
        name: 'CourseLearn',
        component: () => import('@/views/courses/Learn'),
        children: [],
        meta: {
            requiresAuth: true,
        },
        props: (route) => ({
            id: route.params.id,
        }),
    },
    {
        path: '/courses/:id/timetable/:enrollmentId',
        name: 'CourseTimetable',
        component: () => import('@/views/courses/Timetable'),
        children: [],
        meta: {
            requiresAuth: true,
        },
        props: (route) => ({
            id: route.params.courseId,
            enrollmentId: route.params.enrollmentId,
        }),
    },
]

export default courses
